/**
 * Tipos de IVA 2025 y tipo por defecto por categoría de gasto/ingreso.
 * Sustituye el supuesto plano del 21% del estimador de autónomo: cuando un
 * movimiento no trae `taxData.taxAmount` de factura, se deriva el IVA con el tipo
 * por defecto de su categoría (editable por movimiento). Heurístico orientativo.
 */

export const IVA_RATES_2025 = {
    general: 21,
    reduced: 10,
    superReduced: 4,
    exempt: 0,
} as const;

// Exento (sin IVA): sanidad, educación, seguros, servicios financieros, alquiler vivienda.
const EXEMPT_KEYWORDS = ['sanidad', 'sanitar', 'educac', 'formac', 'enseñanza', 'seguro', 'financ', 'alquiler de vivienda'];
// Super-reducido 4%: libros/prensa, medicamentos, alimentos básicos.
const SUPER_REDUCED_KEYWORDS = ['libro', 'prensa', 'revista', 'medicament', 'pan', 'leche', 'fruta', 'verdura', 'huevo', 'cereal'];
// Reducido 10%: hostelería, alimentación general, transporte de viajeros, hotelería.
const REDUCED_KEYWORDS = ['hostel', 'restaurac', 'aliment', 'transporte', 'hotel', 'cafeter', 'comida', 'catering'];

/**
 * Tipo de IVA por defecto (en %) para una categoría/subcategoría. El orden de
 * comprobación (super-reducido → exento → reducido → general) evita colisiones de
 * palabras clave (p.ej. "medicamentos" 4% no debe caer en "medic"→exento).
 */
export function getDefaultIvaRate(category?: string, subCategory?: string): number {
    const hay = `${category ?? ''} ${subCategory ?? ''}`.toLowerCase();
    if (SUPER_REDUCED_KEYWORDS.some(k => hay.includes(k))) return IVA_RATES_2025.superReduced;
    if (EXEMPT_KEYWORDS.some(k => hay.includes(k))) return IVA_RATES_2025.exempt;
    if (REDUCED_KEYWORDS.some(k => hay.includes(k))) return IVA_RATES_2025.reduced;
    return IVA_RATES_2025.general;
}
